import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompSwitchWrapperCore } from '../core/forms/switch/wrapper'
import { CompSwitch } from './CompSwitch'

/**
 * CompSwitchWrapper
 *
 */
function CompSwitchWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompSwitchWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompSwitch {...props} />}
    </CompSwitchWrapperCore>
  )
}


export default CompSwitchWrapper